"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modifiersKeys = [
    'Alt',
    'AltGraph',
    'Control',
    'Meta',
    'Shift',
];
function checkModifierKeyActivated(event) {
    return modifiersKeys.some((key) => event.getModifierState(key));
}
exports.default = checkModifierKeyActivated;
